import { captureException } from '@sentry/browser';
import { LitEntity, renderIf, css, html } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import './device-monitoring-chart';
import './device-details';
import '../../bins/parts/bin-path-name';
import '../../common/bn-surface';
import '../../common/bn-icon';
import './silo-device-monitoring-chart';

class DeviceOverview extends LitEntity {
  static get properties() {
    return {
      show3dAdvancedView: { type: Boolean, attribute: false },
      selectedDate: { type: String, attribute: false },
    };
  }
  static get styles() {
    return [sharedStyles, css`
      .row {
        display: flex;
        justify-content: stretch;
        align-items: stretch;
      }
      .row.attached-bin {
        align-items: center;
        justify-content: space-between;
      }
      .row bn-surface {
        width: 100%;
      }
      device-details {
        --align-value: left;
      }
      .device-monitoring-header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: baseline;
      }
      bn-icon {
        margin-right: .5em;
      }
      h3 {
        margin-top: .5em;
      }
      iframe {
        width: 100%;
        height: 65vh;
        border: none;
      }
    `];
  }

  render() {
    const binHref = this.getHref('https://api.binsentry.com/rel/bin');
    const expandIcon = this.show3dAdvancedView ? 'fa-chevron-up' : 'fa-chevron-down';
    let advancedView = html``;
    if (this.show3dAdvancedView) {
      const toolsSrc = new URL(`https://${window.location.host}/3d-image-tools`);
      toolsSrc.hash = this.selectedDate ? `/publishedAt/${this.selectedDate}/deviceId/${encodeURIComponent(this.href)}` : '';
      advancedView = html`<iframe src="${toolsSrc}">&nbsp</iframe>`;
    }

    return html`
      <div class="row details-row">
        <bn-surface>
          <h3>Details</h3>
          <device-details .href="${this.href}"></device-details>
        </bn-surface>

        ${renderIf(binHref, () => html`
          <bn-card .href="/bins/show/overview?binId=${encodeURIComponent(binHref)}">
            <div class="row attached-bin">
              <h3>Attached Bin</h3>
            </div>
            <div class="row">
              <bin-path-name .href="${binHref}" ancestorMinIndex="0"></bin-path-name>
            </div>
          </bn-card>
        `)}
      </div>

      <div class="row">
        <bn-surface>
          <div class="device-monitoring-header">
            <h3>Device Monitoring</h3>
            <button class="button button--tertiary" @click="${() => this.show3dAdvancedView = !this.show3dAdvancedView}">
              <bn-icon name="fa ${expandIcon}"></bn-icon>3d Advanced View
            </button>
          </div>
          ${advancedView}
          ${this.hardwareType === 'siloSensor'
    ? html`<silo-device-monitoring-chart
              .href="${this.href}"
              ?selectable="${this.show3dAdvancedView}"
              visible-layers="${JSON.stringify(['levels'])}"
              hardware-type="${this.hardwareType}"
              @select="${this._onChartSelect}"
            ></silo-device-monitoring-chart>`
    : html`<device-monitoring-chart
              .href="${this.href}"
              ?selectable="${this.show3dAdvancedView}"
              visible-layers="${JSON.stringify(['levels', 'battery', 'cell', 'batteryTemperature'])}"
              hardware-type="${this.hardwareType}"
              @select="${this._onChartSelect}"
            ></device-monitoring-chart>`
}

        </bn-surface>
      </div>
    `;
  }

  _onChartSelect(e) {
    const { date } = e.detail;
    if (!date) {
      captureException(new Error(`device-overview#onChartSelect date: ${date}, triggered by ${e.target?.tagName}`));
    }
    this.selectedDate = date;
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    if (!entity) {
      return;
    }
    this.hardwareType = entity.properties?.hardwareType;
  }
}

window.customElements.define('device-overview', DeviceOverview);
